import React from "react";
import PropTypes from "prop-types";
import {Tooltip, Typography, useTheme} from "@mui/material";
import {isString} from "underscore";

const StyledTooltip = ({
  backgroundColor,
  children,
  disableHoverListener,
  interactive,
  ref,
  maxWidth,
  opacity,
  placement,
  spanProps = {},
  title,
}) => {
  const theme = useTheme();
  const isDarkTheme = theme.palette.mode === "dark";
  const styledTitle =
    isString(title) ?
      <Typography variant="caption">{title}</Typography> :
      title;

  return (
    <Tooltip
      title={styledTitle}
      disableHoverListener={disableHoverListener}
      disableInteractive={!interactive}
      placement={placement}
      enterDelay={350}
      enterNextDelay={350}
      TransitionProps={{
        style: {
          backgroundColor:
            backgroundColor ?? theme.palette.grey[isDarkTheme ? "700" : "800"],
          borderRadius: 0,
          maxWidth: maxWidth,
          opacity: opacity ?? 1,
        },
      }}
    >
      <span ref={ref} data-testid="tooltip-wrapper" {...spanProps}>
        {children}
      </span>
    </Tooltip>
  );
};

StyledTooltip.propTypes = {
  backgroundColor: PropTypes.string,
  children: PropTypes.any,
  disableHoverListener: PropTypes.bool,
  interactive: PropTypes.bool,
  ref: PropTypes.any,
  maxWidth: PropTypes.number,
  opacity: PropTypes.number,
  placement: PropTypes.string,
  spanProps: PropTypes.object,
  title: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.object,
    PropTypes.node,
  ]),
};

export default StyledTooltip;
